<template>
  <div class="blocked_logs_page">
    <h1>新充值来源数据报表</h1>
    <div class="user-options ">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="ps"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in pss"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="scene"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in scenes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
    </div>
    <div class="user-options ">
      <el-select
        style="width: 160px"
        v-model="isNew"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isNews"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <div class="user-options ">
      <el-table
        :data="tableList"
        border
        v-loading="login1"
      >
        <el-table-column align="center" prop="ps" label="页面"  sortable>
          <template slot-scope="scope">
           {{ps_(scope.row.ps)}}
         </template>
        </el-table-column>
        <el-table-column align="center" prop="scene" label="场景"  sortable>
         <template slot-scope="scope">
           {{changjin(scope.row.scene)}}
         </template>
        </el-table-column>
        <el-table-column align="center" prop="popularCount" label="充值曝光次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="popularUser" label="充值曝光人数"  sortable >
        </el-table-column>
        <el-table-column align="center" prop="clickCount" label="充值点击次数"  sortable >
        </el-table-column>
        <el-table-column align="center" prop="clickUser" label="充值点击人数"  sortable >
        </el-table-column>
        <el-table-column align="center" prop="successCount" label="充值成功次数"  sortable >
        </el-table-column>
        <el-table-column align="center" prop="successUser" label="充值成功人数"  sortable >
        </el-table-column>
      </el-table>
    </div>
     <!-- <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="50"
        class="pagination"
      ></el-pagination>
     </el-row> -->
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      login1: false,
      login2: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      page: 1,
      total: 0,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      isNew: 0,
      isNews: [
        {
          label: '全部用户',
          value: 0
        },
        {
          label: ' 新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      ps: 'total',
      pss: [
        {
          label: 'total',
          value: 'total'
        },
        {
          label: 'all',
          value: 'all'
        },
        {
          label: 'Discover',
          value: 1001
        },
        {
          label: 'Popular',
          value: 1002
        },
        {
          label: 'Nearby',
          value: 1003
        },
        {
          label: 'Follow',
          value: 1004
        },
        {
          label: '匹配',
          value: 1101
        },
        {
          label: 'Live列表',
          value: 1501
        },
        {
          label: '消息列表',
          value: 1202
        },
        {
          label: '资料页',
          value: 1401
        },
        {
          label: '视频资料页',
          value: 1402
        },
        {
          label: '普通通话界面',
          value: 1203
        },
        {
          label: '匹配通话界面（假视频）',
          value: 1104
        },
        {
          label: '匹配通话界面（真实通话）',
          value: 1204
        },
        {
          label: 'Live直播间',
          value: 1503
        },
        {
          label: '匹配结束落地页',
          value: 1103
        },
        {
          label: '私密视频页',
          value: 1403
        },
        {
          label: '历史记录页',
          value: 1205
        },
        {
          label: '钱包页',
          value: 1302
        },
        {
          label: 'Boss等级页',
          value: 1303
        }
      ],
      scene: 'total',
      scenes: [
        {
          label: 'total',
          value: 'total'
        },
        {
          label: 'all',
          value: 'all'
        },
        {
          label: '优惠弹窗',
          value: 0
        },
        {
          label: '拨打余额不足',
          value: 1
        },
        {
          label: '匹配余额不足',
          value: 2
        },
        {
          label: '抽奖（老虎机、砸蛋）余额不足',
          value: 3
        },
        {
          label: '送礼余额不足',
          value: 4
        },
        {
          label: '礼物面板充值按钮点击',
          value: 5
        },
        {
          label: '打招呼解锁余额不足',
          value: 6
        },
        {
          label: 'Whatsapp解锁余额不足',
          value: 7
        },
        {
          label: '通话中倒计时按钮',
          value: 8
        },
        {
          label: '通话后倒计时按钮',
          value: 9
        },
        {
          label: '通话中自动弹出余额不足弹窗',
          value: 10
        },
        {
          label: '钱包页点击',
          value: 11
        },
        {
          label: 'Live预约',
          value: 12
        },
        {
          label: '消息对话窗优惠入口',
          value: 13
        },
        {
          label: '签到解锁弹窗',
          value: 14
        },
        {
          label: 'Boss等级页点击充值',
          value: 15
        },
        {
          label: '评价优惠弹窗',
          value: 16
        }
      ]
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      this.login1 = true
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    // 场景
    changjin(data) {
      let scene = {
        0: '优惠弹窗',
        1: '拨打余额不足',
        2: '匹配余额不足',
        3: '抽奖（老虎机、砸蛋）余额不足',
        4: '送礼余额不足',
        5: '礼物面板充值按钮点击',
        6: '打招呼解锁余额不足',
        7: 'Whatsapp解锁余额不足',
        8: '通话中倒计时按钮',
        9: '通话后倒计时按钮',
        10: '通话中自动弹出余额不足弹窗',
        11: '钱包页点击',
        12: 'Live预约',
        13: '消息对话窗优惠入口',
        14: '签到解锁弹窗',
        15: 'Boss等级页点击充值',
        16: '评价优惠弹窗'
      }
      if(scene[data] == undefined) {
        return data
      }
      return scene[data]
    },
    // 场景
    ps_(data) {
      let scene = {
        1001: 'Discover',
        1002: 'Popular',
        1003: 'Nearby',
        1004: 'Follow',
        1101: '匹配',
        1501: 'Live列表',
        1202: '消息列表',
        1401: '资料页',
        1402: '视频资料页',
        1203: '普通通话界面',
        1104: '匹配通话界面（假视频）',
        1204: '匹配通话界面（真实通话）',
        1503: 'Live直播间',
        1103: '匹配结束落地页',
        1403: '私密视频页',
        1205: '历史记录页',
        1302: '钱包页',
        1303: 'Boss等级页',
      }
      if(scene[data] == undefined) {
        return data
      }
      return scene[data]
    },
    // 分页
    handleCurrentChange() {
      this.get_list()
    },
    async get_list() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.reports_newRechargeSource,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          isNew: this.isNew,
          ps: this.ps,
          scene: this.scene
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.reports_newRechargeSource_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          isNew: this.isNew,
          ps: this.ps,
          scene: this.scene
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(
        res.data,
        '新充值来源数据报表' +
          (this.platformData[0] + '-' + this.platformData[1])
      )
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 20px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
